module.exports = __webpack_public_path__ + "img/ola.3bcceedd.png";